<template>
  <div class="thingDescriptionContainer">
    <div class="mobileHeader">
      <div class="tdSelectContainer">
        <select v-model="searchQ" @change="searchDevice" class="tdSelect">
          <option value="" disabled>Select a device...</option>
          <option v-for="device in devices" :value="device.title" :key="device.id">{{ device.title }}</option>
        </select>
      </div>
    </div>

    <div class="tdList">
      <div class="tdListHeader">
        <label class="tdHeaderLabel">THING DESCRIPTIONS</label>
        <div class="tdInputContainer">
          <input type="text" placeholder="Search TD..." v-model="searchQ" class="tdInput">
        </div>
      </div>
      <div class="tdListContainer">
        <div class="tdListContent">
          <div v-for="device in filteredDevices" :key="device.id" class="tdListItem" @click="showTD(device)"
            :class="{ selectedBack: device === selectedTD }">
            <span class="tdItemText" :class="{ selectedText: device === selectedTD }">{{ device.title }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="tdDisplay">
      <div class="pre-container">
        <pre id="tdJSON" class="json-container"></pre>
        <button class="help-button" @click="showHelp">?</button>
      </div>
    </div>

    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">About Thing Description</v-card-title>
        <v-card-text>
          This window presents a directory with various Thing Descriptions, which are a specification in the context of the Web of Things (IoT). It defines semantic metadata and capabilities of a "thing" on the network, allowing applications and services to discover, use and interact with that "thing" in a standard and consistent manner.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import discoveryAPI from "../services/discoveryAPI";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
  name: "ThingDescriptions",
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      devices: [],
      searchQ: "",
      selectedDevice: null,
      selectedTD: {},
      dialog: false, // Add a new data property for the dialog
    };
  },
  computed: {
    filteredDevices() {
      return this.devices.filter((device) =>
        device.title.toLowerCase().includes(this.searchQ.toLowerCase())
      );
    },
  },
  methods: {
    getTD() {
      discoveryAPI.get("/td").then((response) => {
        this.devices = response.data.items;
        if (this.devices.length > 0) {
          this.selectedDevice = this.devices[0]; // Set the first device as the default selected device
          this.showTD(this.devices[0]); // Show the first device
        }
      });
    },
    showTD(device) {
      this.selectedTD = device;
      console.log("Selected Device:", this.selectedTD); // Add this line for debugging
      document.getElementById("tdJSON").innerHTML = syntaxHighlight(device);
    },
    searchDevice() {
      const selectedDevice = this.devices.find(
        (device) => device.title === this.searchQ
      );
      if (selectedDevice) {
        this.showTD(selectedDevice); // Pass the entire device object, not just the id
      }
    },
    showHelp() {
      console.log("Help button clicked");
      this.dialog = true; // Open the dialog
      console.log("Dialog status:", this.dialog); // Add this line for debugging
    },
  },
  mounted() {
    this.getTD();
  },
};

function syntaxHighlight(json) {
  if (typeof json !== "string") {
    json = JSON.stringify(json, undefined, 2);
  }
  json = json
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
  return json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|\b(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)\b)/g,
    function (match) {
      var cls = "number";
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = "key";
        } else {
          cls = "string";
        }
      } else if (/true|false/.test(match)) {
        cls = "boolean";
      } else if (/null/.test(match)) {
        cls = "null";
      }
      return '<span class="' + cls + '">' + match + "</span>";
    }
  );
}
</script>

<style>
.thingDescriptionContainer {
  display: grid;
  grid-template-columns: 1fr 4fr;
  height: 95vh;
  max-width: 1150px;
  margin: auto;
}

.tdList {
  background-color: #dddfe3;
  display: grid;
  grid-template-rows: auto 1fr;
  place-items: center;
  height: 100%;
  width: 100%;
  border-right: 1px solid #bbb;
  overflow-x: hidden;
}

.tdListHeader {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  background-color: #b0b5bf;
}

.tdInput {
  font-weight: 500;
  width: 95%;
}

.tdInputContainer {
  background-color: white;
  border-radius: 24px;
  margin-bottom: 10px;
  text-align: start;
  display: grid;
  place-items: center;
  padding-left: 10px;
  height: 80%;
  width: 80%;
}

.tdListContainer {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
}

.tdListContainer::-webkit-scrollbar {
  width: 0.5rem;
}

.tdListContent {
  display: grid;
  place-items: center;
  width: 100%;
}

.tdListContent>div:nth-child(even) {
  background-color: #d9d9d9;
}

.tdListContent>div:nth-child(odd) {
  background-color: #c6c6c6;
}

.tdListContent>div {
  padding: 0.4rem;
  cursor: pointer;
}

.tdListItem {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.tdItemText {
  font-weight: 500;
  font-size: 1rem;
  color: #63635b;
  margin: 0.8rem;
}

.tdHeaderLabel {
  font-weight: 700;
  font-size: 1.1rem;
  color: #fff;
}

.tdDisplay {
  height: 100%;
  padding: 1rem;
  overflow: auto;
}

.selectedBack {
  background-color: rgba(46, 48, 56, 0.4) !important;
}

.selectedText {
  color: white;
}

.json-container {
  font-family: monospace;
  font-size: 1rem;
  background-color: #2f2f2f;
  padding: 1rem;
  color: #d4d4d4;
  border-radius: 5px;
  overflow-x: scroll;
  width: 100%;
  height: 100%;
}

.json-container .string {
  color: #ce9178;
}

.json-container .number {
  color: #b5cea8;
}

.json-container .boolean {
  color: #569cd6;
}

.json-container .null {
  color: #b5cea8;
}

.json-container .key {
  color: #9cdcfe;
}

.json-container::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
}

.pre-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.help-button {
  position: absolute;
  top: 12px;
  right: 15px;
  opacity: 0.7;
  background-color: #7a7c80;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 16px;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: ease-in-out 0.2s;
}

.help-button:hover {
  background-color: #636469;
  transition: ease-in-out 0.2s;
}

.mobileHeader {
  display: none;
}

@media (max-width: 768px) {
  .thingDescriptionContainer {
    grid-template-columns: 1fr;
  }

  .tdList {
    display: none;
  }

  .tdInputContainer {
    display: none;
  }

  .tdSelectContainer {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }

  .tdInput {
    display: none;
  }

  .tdSelect {
    width: 80%;
    padding: 0.5rem;
    border-radius: 24px;
    border: 1px solid #bbb;
  }

  .tdListContainer {
    display: none;
  }

  .tdDisplay {
    position: relative;
    background: transparent;
    height: 100% !important;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .tdListContainer {
    display: none;
  }

  .tdDisplay {
    display: block;
  }

  .mobileHeader {
    display: inline-block;
    height: 50px;
    /* Adjust this value as needed */
    max-height: 50px;
    /* Adjust this value as needed */
  }

}
</style>
